import {SVGProps} from "react";

export const ChevronDownSvg = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path d="M15.8337 7.5L10.0003 13.3333L4.16699 7.5" stroke="currentColor" strokeWidth="1.25"
                  strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}
